import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  planId: string;
  taskId: string;
  data: any
}

const mutateCascadePreviewTask = async ({projectId, planId, taskId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/plans/${planId}/tasks/${taskId}/cascade-preview`, data);
};

const useCascadePreviewTaskMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateCascadePreviewTask,
    ...queryParams,
  });

export default useCascadePreviewTaskMutation;
